export default __webpack_public_path__ + "static/media/ucook.49a94bca.mp4";